import React, { Component } from "react";

export class Receiveables extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div className="ui-g">
        <div className="ui-g-12">
          <div className="card">
            <h1>Receiveables</h1>
            <p>
              This page will display a list of Receiveables to sync to
              accountancy package generated by Invoice's within BPMBuild.
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Receivable/Receiveables.js